import { render, staticRenderFns } from "./app-left-navigation.vue?vue&type=template&id=aa7b2aa8&scoped=true&"
import script from "./app-left-navigation.vue?vue&type=script&lang=js&"
export * from "./app-left-navigation.vue?vue&type=script&lang=js&"
import style0 from "./app-left-navigation.vue?vue&type=style&index=0&id=aa7b2aa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7b2aa8",
  null
  
)

export default component.exports